<template>
  <ComingSoonFeatureVote
    :title="$t('broker.onevsone.duels')"
    :description="$t('broker.onevsone.oneVsOneDescription')"
    :image-src="imageSrc"
    feature-name="COMING_FEATURE_DUELS1VS1"
  />
</template>

<script>
import ComingSoonFeatureVote from "../components/ComingSoonFeatureVote.vue";

export default {
  name: "OneVsOneView",
  components: {
    ComingSoonFeatureVote,
  },
  data() {
    return {
      imageSrc: require("../assets/Image-Duels.png"),
    };
  },
};
</script>
